@if (
  (('portal-mobile-setting-confirm-shift' | featureFlagPure | async) &&
    (canConfirmShift$ | async)) ||
  (('portal-mobile-settings-decline-shift' | featureFlagPure | async) &&
    (canDeclineShift$ | async))
) {
  <div>
    <span class="mb-0 filter-label">
      {{ 'page.shift_timeline.filter.acceptance_status' | translate }}
    </span>
    <nz-select
      nzMode="multiple"
      [nzPlaceHolder]="
        placeholder || ('shift.filter.confirm_decline.placeholder' | translate)
      "
      nzAllowClear
      [nzShowArrow]="true"
      (ngModelChange)="saveSelected($event)"
      [ngModel]="selected$ | async"
    >
      @if (
        ('portal-mobile-setting-confirm-shift' | featureFlagPure | async) &&
        (canConfirmShift$ | async)
      ) {
        <nz-option
          [nzLabel]="'shift.filter.confirm_decline.confirmed_at' | translate"
          [nzValue]="'confirmed'"
        >
          {{ 'shift.filter.confirm_decline.confirmed_at' | translate }}
        </nz-option>
      }
      @if (
        ('portal-mobile-settings-decline-shift' | featureFlagPure | async) &&
        (canDeclineShift$ | async)
      ) {
        <nz-option
          [nzLabel]="'shift.filter.confirm_decline.declined_at' | translate"
          [nzValue]="'declined'"
        >
          {{ 'shift.filter.confirm_decline.declined_at' | translate }}
        </nz-option>
      }
    </nz-select>
  </div>
  @if (showLabel) {
    <wilson-filter-label
      [label]="'shift.filter.confirm_decline.label' | translate"
    ></wilson-filter-label>
  }
}
